import React, { FC } from 'react';
import { PlayerState } from '../../../types';
import { Modal } from '../Modal';
import { GameSearch } from './GameSearch';

import { containerStyles } from './styles.css';

type SearchModalProps = {
  isOpen: boolean;
  player?: PlayerState;
  enemy?: PlayerState;
};

const SearchModal: FC<SearchModalProps> = ({ isOpen, player, enemy }) => (
  <Modal.Adaptive isOpen={isOpen}>
    <div className={containerStyles}>
      <GameSearch player={player} enemy={enemy} />
    </div>
  </Modal.Adaptive>
);

export default SearchModal;
